export default function () {
  return {
    // links (each with a populated `tag`) matching `filter`; the socket handlers re-fetch with the same filter
    list: [],
    filter: null // { resourceType, resourceId?, tag? } of the last list() call
  }
}
